import MONSTRO_3 from "url:../sprites/fumego.png";
import SOM_3 from "url:../sfx/huuooo.m4a";

export default {
  attack: 3,
  life: 5,
  speed: 4,
  agility: 4,
  image: MONSTRO_3,
  sound: SOM_3,
};
